module.exports = __webpack_public_path__ + "img/km.11612d47.svg";